import { IconSvgProps } from '../types';

export const PageRefresh = ({ size }: IconSvgProps) => (
  <svg
    id="icon-content-page refresh"
    width={size}
    height={size}
    viewBox="0 0 52 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <path d="M51.57,56.85 C51.57,60.97 48.23,64.31 44.12,64.31 L7.46,64.31 C3.34,64.31 0,60.97 0,56.85 L0,7.76 C0,3.65 3.34,0.31 7.46,0.31 L36.04,0.31 L36.04,0.31 L36.04,15.84 L51.57,15.84 L51.57,56.85 Z M40.7,35.33 C40.7,27.27 34.16,20.73 26.1,20.73 L24.77,20.73 L25.59,19.91 L25.68,19.81 C26.68,18.72 26.65,17.02 25.59,15.96 C24.5,14.86 22.73,14.86 21.63,15.96 L16.04,21.55 L15.95,21.64 C14.95,22.74 14.98,24.44 16.04,25.5 L21.63,31.09 L21.73,31.19 C22.83,32.19 24.53,32.16 25.59,31.09 L25.68,31 C26.68,29.9 26.65,28.2 25.59,27.14 L24.77,26.32 L26.1,26.32 L26.29,26.32 C31.18,26.43 35.11,30.42 35.11,35.33 L35.11,35.46 C35.18,36.95 36.4,38.13 37.9,38.13 C39.45,38.13 40.7,36.88 40.7,35.33 Z M17.09,35.33 C17.09,33.79 15.84,32.54 14.29,32.54 C12.75,32.54 11.5,33.79 11.5,35.33 C11.5,43.02 17.44,49.32 24.98,49.89 L24.12,50.75 C23.06,51.81 23.03,53.51 24.03,54.61 L24.12,54.71 C25.18,55.77 26.88,55.8 27.98,54.8 L28.07,54.71 L33.67,49.11 C34.73,48.05 34.76,46.35 33.76,45.25 L33.67,45.16 L28.07,39.57 C26.98,38.48 25.21,38.48 24.12,39.57 C23.06,40.63 23.03,42.33 24.03,43.43 L24.12,43.52 L24.85,44.26 C20.47,43.65 17.09,39.89 17.09,35.33 Z" />
        <polygon opacity="0.5" points="51.57 15.84 36.04 15.84 36.04 0.31" />
      </g>
    </g>
  </svg>
);
